// in UserTableRow.tsx
import React from 'react';
import { User } from '../types';
import { Icons } from '@/icons';
import { formatLocalDate } from '@/utils/FormateLocalDate';

interface Props {
  user: User;
  idx: string;
  onDelete(idx: string): void;
}

const UserTableRow: React.FC<Props> = ({ user, idx, onDelete }) => (
  <tr>
    <td className='p-4'>{user.name}</td>
    <td className='p-4'>{formatLocalDate(user.created_at)}</td>
    <td className='p-4'>{user.email}</td>
    <td className='p-4'>{user.phone}</td>
    <td className='p-4'>
      <span className={user.is_active ? 'text-[#21B803]' : 'text-[#FBBC05]'}>
        {user.is_active ? 'Active' : 'Inactive'}
      </span>
    </td>
    <td className='p-4'>{user.gender}</td>
    <td className='p-4'>
      <Icons.Delete onClick={() => onDelete(idx)} />
    </td>
  </tr>
);

export default UserTableRow;
